<template>
  <b-modal id="modal-retirada-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalRetiradaDetalhe">
    <template v-slot:modal-header>
      <h5>Detalhes do Pedido de Retirada</h5>
    </template>

    <template v-slot:default>
      <template v-if="loading">
        <div class="text-center py-4">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem" label="Carregando"></b-spinner>
          <br /><span style="color: #004e86">Processando Aguarde...</span>
        </div>
      </template>

      <template v-else-if="error">
        <b-alert show variant="danger">Erro ao carregar os detalhes do pedido.</b-alert>
      </template>

      <template v-else>
        <b-row>
          <!-- Coluna esquerda: Dados do Título -->
          <b-col cols="12" md="4" class="mb-3 mb-md-0">
            <div class="modal-card h-100">
              <div class="modal-card-header">
                <h3>Dados do Título</h3>
              </div>
              <div class="modal-card-body">
                <div class="info-row"><span class="info-label">Chave Única</span><span class="info-value text-truncate-cell">{{ titulo.nm_chave }}</span></div>
                <div class="info-row"><span class="info-label">Nosso Número</span><span class="info-value">{{ titulo.nm_nosso_numero }}</span></div>
                <div class="info-row"><span class="info-label">Nº Título</span><span class="info-value">{{ titulo.nm_nr_titulo }}</span></div>
                <div class="info-row"><span class="info-label">Devedor</span><span class="info-value">{{ titulo.nm_devedor }}</span></div>
                <div class="info-row"><span class="info-label">Doc. Devedor</span><span class="info-value">{{ formatDocumento(titulo.nm_nr_documento_devedor) }}</span></div>
                <div class="info-row"><span class="info-label">Valor Título</span><span class="info-value">{{ formatCurrency(titulo.vl_titulo) }}</span></div>
                <div class="info-row"><span class="info-label">Valor Protestado</span><span class="info-value">{{ formatCurrency(titulo.vl_protesto) }}</span></div>
                <div class="info-row"><span class="info-label">Nº Protocolo</span><span class="info-value">{{ titulo.nm_nr_protocolo }}</span></div>
                <div class="info-row"><span class="info-label">Dt. Protocolo</span><span class="info-value">{{ formatData(titulo.dt_protocolo) }}</span></div>
                <div class="info-row"><span class="info-label">Dt. Emissão</span><span class="info-value">{{ formatData(titulo.dt_emissao) }}</span></div>
                <div class="info-row"><span class="info-label">Dt. Vencimento</span><span class="info-value">{{ formatData(titulo.dt_vencimento) }}</span></div>
                <div class="info-row"><span class="info-label">Dt. Ocorrência</span><span class="info-value">{{ formatData(titulo.dt_ocorrencia) }}</span></div>
              </div>
            </div>
          </b-col>

          <!-- Coluna direita: Pedido + Cartório + Solicitante -->
          <b-col cols="12" md="8" class="d-flex flex-column" style="gap: 12px;">

            <!-- Dados do Pedido de Retirada -->
            <div class="modal-card">
              <div class="modal-card-header">
                <h3>Dados do Pedido de Retirada</h3>
              </div>
              <div class="modal-card-body">
                <b-row>
                  <b-col cols="3"><div class="info-row-v"><span class="info-label">Nº Pedido</span><span class="info-value">{{ pedido.cd_pedido_retirada }}</span></div></b-col>
                  <b-col cols="3"><div class="info-row-v"><span class="info-label">Dt. Solicitação</span><span class="info-value">{{ formatDataHora(pedido.dt_cadastro) }}</span></div></b-col>
                  <b-col cols="3">
                    <div class="info-row-v">
                      <span class="info-label">Status</span>
                      <b-badge
                        :style="'background-color:' + corStatus(pedido.cd_pedido_retirada_status)"
                        class="px-2 py-1 badge-truncate"
                        :title="pedido.nm_status"
                        v-b-tooltip.hover
                      >{{ pedido.nm_status }}</b-badge>
                    </div>
                  </b-col>
                  <b-col cols="3"><div class="info-row-v"><span class="info-label">Pedido de Protesto</span><span class="info-value">{{ pedido.cd_pedido_protesto }}</span></div></b-col>
                </b-row>
                <b-row class="mt-2">
                  <b-col cols="12" md="4"><div class="info-row-v"><span class="info-label">Valor Retirada</span><span class="info-value">{{ formatCurrency(pedido.vl_retirada) }}</span></div></b-col>
                </b-row>
              </div>
            </div>

            <!-- Dados do Cartório -->
            <div class="modal-card">
              <div class="modal-card-header">
                <h3>Dados do Cartório</h3>
              </div>
              <div class="modal-card-body">
                <b-row>
                  <b-col cols="12" md="8" class="mb-2"><div class="info-row-v"><span class="info-label">Nome</span><span class="info-value">{{ cartorio.nm_cartorio }}</span></div></b-col>
                  <b-col cols="12" md="4" class="mb-2"><div class="info-row-v"><span class="info-label">CNPJ</span><span class="info-value">{{ formatDocumento(cartorio.cnpj) }}</span></div></b-col>
                  <b-col cols="2" class="mb-2"><div class="info-row-v"><span class="info-label">UF</span><span class="info-value">{{ cartorio.uf }}</span></div></b-col>
                  <b-col cols="5" class="mb-2"><div class="info-row-v"><span class="info-label">Cidade</span><span class="info-value">{{ cartorio.cidade }}</span></div></b-col>
                  <b-col cols="5" class="mb-2"><div class="info-row-v"><span class="info-label">Nº Cartório</span><span class="info-value">{{ cartorio.nr_cartorio }}</span></div></b-col>
                  <b-col cols="6"><div class="info-row-v"><span class="info-label">Telefone</span><span class="info-value">{{ formatTelefone(cartorio.telefone) }}</span></div></b-col>
                  <b-col cols="6"><div class="info-row-v"><span class="info-label">E-mail</span><span class="info-value text-truncate-cell" :title="cartorio.email">{{ cartorio.email }}</span></div></b-col>
                </b-row>
              </div>
            </div>

            <!-- Dados do Solicitante -->
            <div class="modal-card">
              <div class="modal-card-header">
                <h3>Dados do Solicitante</h3>
              </div>
              <div class="modal-card-body">
                <b-row>
                  <b-col cols="12" md="4" class="mb-2"><div class="info-row-v"><span class="info-label">Nome</span><span class="info-value">{{ solicitante.nm_usuario }}</span></div></b-col>
                  <b-col cols="12" md="4" class="mb-2"><div class="info-row-v"><span class="info-label">Documento</span><span class="info-value">{{ formatDocumento(solicitante.nm_nr_cpfcnpj) }}</span></div></b-col>
                  <b-col cols="12" md="4" class="mb-2"><div class="info-row-v"><span class="info-label">E-mail</span><span class="info-value text-truncate-cell" :title="solicitante.nm_email">{{ solicitante.nm_email }}</span></div></b-col>
                  <b-col cols="6"><div class="info-row-v"><span class="info-label">Telefone</span><span class="info-value">{{ formatTelefone(solicitante.nm_nr_telefone) }}</span></div></b-col>
                  <b-col cols="6"><div class="info-row-v"><span class="info-label">Celular</span><span class="info-value">{{ formatTelefone(solicitante.nm_nr_celular) }}</span></div></b-col>
                </b-row>
              </div>
            </div>

          </b-col>
        </b-row>
      </template>
    </template>

    <template v-slot:modal-footer>
      <b-button v-if="canDownloadPdf" size="lg" variant="danger" :disabled="loadingPdf" @click="baixarPdf">
        <b-spinner v-if="loadingPdf" small></b-spinner>
        <font-awesome-icon v-else icon="file-pdf" />
        {{ loadingPdf ? 'Aguarde...' : 'Baixar PDF' }}
      </b-button>
      <b-button size="lg" variant="success" @click="fechar">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import API from '../../services/api';

export default {
  name: 'RetiradaDetalhe',
  data() {
    return {
      loading: false,
      loadingPdf: false,
      error: false,
      cdAtual: null,
      pedido:     {},
      titulo:     {},
      cartorio:   {},
      solicitante: {},
    };
  },
  computed: {
    canDownloadPdf() {
      // Backend will return ic_exibe_pdf truthy (1/true) when PDF is available
      return !!(this.pedido && (this.pedido.ic_exibe_pdf === 1 || this.pedido.ic_exibe_pdf === true));
    }
  },
  methods: {
    abrir(cdPedidoRetirada) {
      this.cdAtual      = cdPedidoRetirada;
      this.pedido       = {};
      this.titulo       = {};
      this.cartorio     = {};
      this.solicitante  = {};
      this.error        = false;
      this.$bvModal.show('modal-retirada-detalhe');
      this.carregarDados(cdPedidoRetirada);
    },

    abrirMock() {
      this.preCarregarMock();
      this.$bvModal.show('modal-retirada-detalhe');
    },

    preCarregarMock() {
      this.cdAtual = 'TUTORIAL';
      this.error   = false;
      this.loading = false;
      this.pedido  = { cd_pedido_retirada: 'TUTORIAL', cd_pedido_protesto: '000000', dt_cadastro: new Date().toISOString(), cd_pedido_retirada_status: 2, nm_status: 'Aguardando Pagamento' };
      this.titulo  = { nm_chave: '00000000000000000000000000001', nm_nosso_numero: '00000001', nm_nr_titulo: '00000000001', nm_devedor: 'DEVEDOR EXEMPLO DA SILVA', nm_nr_documento_devedor: '00000000000', vl_titulo: 1500.00, vl_protesto: 1500.00, nm_nr_protocolo: '000000/2026', dt_protocolo: new Date().toISOString(), dt_emissao: new Date().toISOString(), dt_vencimento: new Date().toISOString(), dt_ocorrencia: new Date().toISOString() };
      this.cartorio = { nm_cartorio: 'CARTÓRIO EXEMPLO', cnpj: '00000000000100', uf: 'SP', cidade: 'São Paulo', nr_cartorio: '1', telefone: '1100000000', email: 'cartorio@exemplo.com.br' };
      this.solicitante = { nm_usuario: 'USUÁRIO EXEMPLO', nm_nr_cpfcnpj: '00000000000', nm_email: 'usuario@exemplo.com.br', nm_nr_telefone: '1100000000', nm_nr_celular: '11900000000' };
    },

    fechar() {
      this.$bvModal.hide('modal-retirada-detalhe');
      this.$emit('fechado');
    },

    async carregarDados(cdPedidoRetirada) {
      this.loading = true;
      this.error = false;
      try {
        const res = await API.get('pedido_retirada/' + cdPedidoRetirada + '/detalhe');
        const d = res.data && res.data.data ? res.data.data : {};
        this.pedido      = d.pedido      || {};
        this.titulo      = d.titulo      || {};
        this.cartorio    = d.cartorio    || {};
        this.solicitante = d.solicitante || {};
      } catch (err) {
        console.error(err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    async baixarPdf() {
      if (this.cdAtual === 'TUTORIAL') {
        this.$bvToast.toast('Esta é uma solicitação de exemplo do tutorial. O PDF não está disponível.', {
          title: 'Tutorial',
          variant: 'info',
          solid: true,
        });
        return;
      }
      this.loadingPdf = true;
      try {
        const res = await API.get('pedido_retirada/' + this.cdAtual + '/pdf');

        // Backend retorna { success: true, pdf: "base64..." }
        const base64 = (res.data && typeof res.data.pdf === 'string')
          ? res.data.pdf
          : (res.data && typeof res.data.dados === 'string')
            ? res.data.dados
            : (typeof res.data === 'string' ? res.data : null);

        if (!base64) throw new Error('PDF não retornado pelo servidor.');

        // Converte base64 → Uint8Array → Blob para evitar limite de data: URI
        const byteChars   = atob(base64);
        const byteNumbers = new Uint8Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
          byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const blob    = new Blob([byteNumbers], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', 'retirada_' + this.cdAtual + '.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
      } catch (err) {
        console.error(err);
        this.$bvToast.toast('Não foi possível baixar o PDF da solicitação de retirada.', {
          title: 'Erro ao baixar PDF',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.loadingPdf = false;
      }
    },

    formatData(data) {
      if (!data) return '';
      return String(data).split(' ')[0].split('-').reverse().join('/');
    },

    formatDataHora(data) {
      if (!data) return '';
      const partes = String(data).split(' ');
      const dataPart = partes[0].split('-').reverse().join('/');
      const horaPart = partes[1] ? partes[1].substring(0, 5) : '';
      return horaPart ? dataPart + ' ' + horaPart : dataPart;
    },

    formatCurrency(val) {
      const n = parseFloat(val);
      if (isNaN(n)) return '';
      return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },

    formatDocumento(doc) {
      if (!doc) return '';
      const v = String(doc).replace(/\D/g, '');
      if (v.length <= 11) {
        return v.replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      }
      return v.replace(/^(\d{2})(\d)/, '$1.$2')
              .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
              .replace(/\.(\d{3})(\d)/, '.$1/$2')
              .replace(/(\d{4})(\d)/, '$1-$2');
    },

    formatTelefone(phone) {
      if (!phone) return '';
      const v = String(phone).replace(/\D/g, '');
      return v.replace(/(\d{2})(\d)/, '($1) $2')
              .replace(/(\d{4,5})(\d{4})$/, '$1-$2');
    },

    corStatus(status) {
      const map = {
        1: '#6c757d',
        2: '#ffc107',
        3: '#17a2b8',
        4: '#dc3545',
        5: '#28a745',
      };
      return map[status] || '#6c757d';
    },
  },
};
</script>

<style scoped>
.modal-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.modal-card-header {
  background: #f0f4f8;
  border-bottom: 1px solid #dee2e6;
  padding: 10px 16px;
}

.modal-card-header h3 {
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
  color: #1a5276;
  letter-spacing: 0.01em;
}

.modal-card-body {
  padding: 14px 16px 10px 16px;
}

/* Linha de informação no card do Título (label acima, valor abaixo) */
.info-row {
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-row:last-child {
  border-bottom: none;
}

/* Variante vertical usada nos cards da coluna direita */
.info-row-v {
  display: flex;
  flex-direction: column;
  margin-bottom: 2px;
}

.info-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.2;
  margin-bottom: 2px;
}

.info-value {
  font-size: 0.875rem;
  color: #333;
  line-height: 1.4;
  word-break: break-word;
}

/* E-mail e chaves longas: trunca com reticências e mostra title no hover */
.text-truncate-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  max-width: 100%;
}

.badge-truncate {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  color: #fff !important;
  font-size: 0.78rem;
  cursor: default;
}
</style>
